import { OB_STEPS } from "../../Containers/GettingStartedPage/utils/onboardingSteps"

export const getOnboardingAccess = ({ nextCreateAccountStep, isInvite }) => {
  const safeNextStep = nextCreateAccountStep ?? 1

  const isStepCompleted = (step) => step < safeNextStep
  const isStepCurrent = (step) => step === safeNextStep

  const completedPrimarySteps = safeNextStep > OB_STEPS.EMAIL ? 1 : Math.max(0, safeNextStep - 2)
  const completedSecondarySteps = Math.max(0, safeNextStep - 3)
  const completedBusinessStep = Math.max(0, safeNextStep - (isInvite ? 1 : 2))

  return {
    isStepCompleted,
    isStepCurrent,
    completedPrimarySteps,
    completedSecondarySteps,
    completedBusinessStep
  }
}
